import { render, staticRenderFns } from "./AutomationWizardOverviewContainer.vue?vue&type=template&id=687971c0&scoped=true&"
import script from "./AutomationWizardOverviewContainer.vue?vue&type=script&lang=js&"
export * from "./AutomationWizardOverviewContainer.vue?vue&type=script&lang=js&"
import style0 from "./AutomationWizardOverviewContainer.vue?vue&type=style&index=0&id=687971c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687971c0",
  null
  
)

export default component.exports